import Vue from 'vue';
import { plural } from '@razlet/utils';
import RouteLeg from './leg';
import RouteTransfer from './transfer';
import { unixTimeToStr } from '~/utils/date';

export default class RouteSegment {
  #legs = [];

  constructor (legs = []) {
    this.#legs = legs;
  }

  get legs () {
    return this.#legs;
  }

  get firstLeg () {
    return this.legs.at(0);
  }

  get lastLeg () {
    return this.legs.at(-1);
  }

  get date () {
    return this.firstLeg.departure.date;
  }

  get uid () {
    return [
      ...this.legs.map(leg => {
        return [
          leg.departure.code,
          leg.departure.date.timeUid,
          leg.waitTime,
          leg.arrival.date.timeUid,
          leg.arrival.code,
        ].join('.');
      }),
    ].join('-');
    /* return [
      this.firstLeg.departure.code,
      this.firstLeg.departure.date.timeUid,
      this.lastLeg.arrival.date.timeUid,
      this.lastLeg.arrival.code,
    ].join(''); */
  }

  get transfers () {
    if (this.legs.length === 1) return [];
    const transfers = [];
    this.legs.forEach((leg, i) => {
      if (i === 0) {
        transfers.push(new RouteTransfer(leg.arrival.data, leg.waitTime, leg.dictionary));
      } else {
        if (this.legs[i - 1].arrival.code === leg.departure.code) {
          transfers.at(-1).addFrom(leg.departure.data, leg.waitTime);
        } else {
          transfers.at(-1).addTo(leg.departure.data, leg.waitTime);
        }
        if (i !== this.legs.length - 1) {
          transfers.push(new RouteTransfer(leg.arrival.data, leg.waitTime, leg.dictionary));
        }
      }
    });
    return transfers;
  }

  get longName () {
    return `${this.firstLeg.departure.name} — ${this.lastLeg.arrival.name}`;
  }

  get shortName () {
    return `${this.firstLeg.departure.shortName} — ${this.lastLeg.arrival.shortName}`;
  }

  get companies () {
    const companies = this.#legs.reduce((res, item, i) => {
      const { company, companyName } = item;

      const isCompanyNotEquals = i === 0 || (i && this.legs[i - 1].company !== item.company);

      if (isCompanyNotEquals) {
        res.push({
          code: company,
          title: companyName,
        });
      }

      return res;
    }, []);
    return [...new Map(companies.map(m => [m.code, m])).values()];
  }

  get tripTime () {
    let tripTime = 0;
    this.#legs.forEach(item => {
      if (item instanceof RouteLeg) {
        tripTime += item.tripTime;
        tripTime += item.waitTime;
      }
    });
    return tripTime;
  }

  get tripTimePretty () {
    return unixTimeToStr(this.tripTime, 'letters');
  }

  get transferType () {
    if (!this.transfers.length) return Vue.prototype.$localize.t('route.direct');
    const transfersCount = this.transfers.length;
    const message = plural(transfersCount, Vue.prototype.$localize.t('route.transfersPlural'));
    return `${transfersCount} ${message}`;
  }

  get numbers () {
    return this.legs.map(leg => leg.fullNumber);
  }

  get points () {
    if (!this.legs.length) return [];
    return this.legs.reduce((points, item, index) => {
      if (index === 0) {
        points.push(item.departure);
      }
      points.push(...item.stopovers);
      points.push(item.arrival);
      return points;
    }, []);
  }
};
